import { useEffect, useState } from 'react';
import { Loadable } from 'recoil';

const CustomLoadable = <T>(loadValue: Loadable<T>, state = true): [T, boolean] => {
  const [isLoading, setLoading] = useState<boolean>(state);
  const [result, setResult] = useState<any>();
  useEffect(() => {
    if (loadValue.state === 'hasValue') {
      setLoading(false);
      setResult(loadValue.contents);
    }
  }, [loadValue]);
  return [result, isLoading];
};

export default CustomLoadable;
